import { Validators } from '@angular/forms';

import {
    DynamicField,
    DynamicFieldType,
    DynamicFieldTypes,
    DynamicLabel,
    noZeroRequiredValidator,
    InputTypes,
    NumericInputTypes,
    SelectInputTypes,
} from '@mt-ng2/dynamic-form';

import { IExpandableObject } from '../expandable-object';
import { IUserRole } from '../interfaces/user-role';

export interface IUserRoleDynamicControlsParameters {
    formGroup?: string;
}

export class UserRoleDynamicControls {

    formGroup: string;

    Form: IExpandableObject;
    View: IExpandableObject;

    constructor(private userrole?: IUserRole, additionalParameters?: IUserRoleDynamicControlsParameters) {
        this.formGroup = additionalParameters && additionalParameters.formGroup || 'UserRole';

        this.Form = {
            Description: new DynamicField({
                formGroup: this.formGroup,
                label: 'Description',
                name: 'Description',
                options: null,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: null,
                    scale: null,
                }),
                validation: [ Validators.maxLength(500) ],
                validators: { 'maxlength': 500 },
                value: this.userrole && this.userrole.hasOwnProperty('Description') && this.userrole.Description != null ? this.userrole.Description.toString() : '',
            }),
            IsEditable: new DynamicField({
                formGroup: this.formGroup,
                label: 'Is Editable',
                name: 'IsEditable',
                options: null,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Checkbox,
                    inputType: null,
                    scale: null,
                }),
                validation: [  ],
                validators: {  },
                value: this.userrole && this.userrole.hasOwnProperty('IsEditable') && this.userrole.IsEditable != null ? this.userrole.IsEditable : true,
            }),
            Name: new DynamicField({
                formGroup: this.formGroup,
                label: 'Name',
                name: 'Name',
                options: null,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: null,
                    scale: null,
                }),
                validation: [ Validators.required, Validators.maxLength(50) ],
                validators: { 'required': true, 'maxlength': 50 },
                value: this.userrole && this.userrole.hasOwnProperty('Name') && this.userrole.Name != null ? this.userrole.Name.toString() : '',
            }),
        };

        this.View = {
            Description: new DynamicLabel({
                label: 'Description',
                value: this.userrole && this.userrole.hasOwnProperty('Description') && this.userrole.Description != null ? this.userrole.Description.toString() : '',
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: null,
                    scale: null,
                }),
            }),
            IsEditable: new DynamicLabel({
                label: 'Is Editable',
                value: this.userrole && this.userrole.hasOwnProperty('IsEditable') && this.userrole.IsEditable != null ? this.userrole.IsEditable : true,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Checkbox,
                    inputType: null,
                    scale: null,
                }),
            }),
            Name: new DynamicLabel({
                label: 'Name',
                value: this.userrole && this.userrole.hasOwnProperty('Name') && this.userrole.Name != null ? this.userrole.Name.toString() : '',
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: null,
                    scale: null,
                }),
            }),
        };

    }
}
